import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Damages resulting from failure to comply with the usage conditions recommended by the manufacturer or distributor;',
          'Aesthetic damages;',
          'Goods paid for with a card other than a Shine Business World Debit card.',
        ],
        title: 'This warranty does not include',
      },
      include: {
        items: [
          'Reimbursement of material goods purchased entirely or partially with the Shine card;',
          'Up to {0} € reimbursed.',
        ],
        title: 'This warranty includes',
      },
    },
    similarOffersTitle: 'Related insurances',
    title: 'Purchase Protection',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Les dommages résultant du non-respect des conditions d’utilisation préconisées par son fabricant ou son distributeur ;',
          'Les dommages esthétiques ;',
          'Les biens payés avec une carte autre qu’une carte Business World Debit émise par Shine.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          'Le remboursement des biens matériels achetés intégralement ou partiellement avec la carte Shine ;',
          'Jusqu’à {0} € remboursés.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Protection des achats',
  },
} as const);

export default locales;
